var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vx-col"},[_c('span',[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"flex"},[_c('div',{staticClass:"w-1/5 bg-grid-color h-12"},[_vm._v("Name")]),_c('div',{staticClass:"w-4/5 bg-grid-color-secondary h-12"},[_vm._v(" : "),_c('b',[_vm._v(_vm._s(this.data.name))])])]),_c('list',{attrs:{"url":_vm.url}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }